import React from "react";
import { CustomText } from "../../../components";
import { fonts } from "../../../config";
import { masks } from "../../../utils";
import { StylesGuest, StylesForm } from "../styles";
import Grid from "@mui/material/GridLegacy";
import { SubmitButton } from "../../../components/newComponents";

function ServiceProviderForm({ data, onSubmit }) {
  return (
    <StylesForm.HeaderSteps>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            NOME COMPLETO
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.name}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            DOCUMENTO
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.document}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            E-MAIL
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.email}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        {data?.primaryGuest?.phone && (
          <Grid item xs={12} md={12}>
            <CustomText
              style={{ paddingBottom: "6px" }}
              fontSize={1.75}
              fontFamily={fonts.semibold}
              textColor="#4D585A"
            >
              TELEFONE
            </CustomText>
            <CustomText
              style={{ paddingBottom: "6px" }}
              fontSize={2}
              fontFamily={fonts.semibold}
              textColor="#24272A"
            >
              {masks.inputMaskTELWithDDD(data?.primaryGuest?.phone)}
            </CustomText>
            <StylesGuest.Line />
          </Grid>
        )}
      </Grid>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "8px",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <SubmitButton fullWidth={false} type="button" onClick={() => onSubmit({})}>
          Confirmar
        </SubmitButton>
      </div>
    </StylesForm.HeaderSteps>
  );
}

export default ServiceProviderForm;
